import Vue from "vue";

const setGridView = (localStorageKey, gridContextMenuEvent, typeView) => {
  const stateGridSubscribers = Vue.localStorage.get(localStorageKey);

  if (stateGridSubscribers) {
    const gridState = JSON.parse(stateGridSubscribers);
    if (gridState) {
      gridContextMenuEvent.columnApi.applyColumnState({
        state: gridState,
        applyOrder: true
      });
    }
  } else {
    if (typeView === "full") {
      const allColumnIds = [];
      gridContextMenuEvent.columnApi.getAllColumns().forEach(column => {
        allColumnIds.push(column.colId);
      });
      gridContextMenuEvent.columnApi.autoSizeColumns(allColumnIds, false);
    } else if (typeView === "optimal") {
      gridContextMenuEvent.api.sizeColumnsToFit();
    }
  }
};

export { setGridView };
